export enum NdaWorkflow {
  None = 'none',
  // Institution = 'institution',
  Personal = 'personal',
}

export const NDA_WORKFLOW_OPTIONS = [
  { value: NdaWorkflow.None, label: 'GNR_REP_NONE' },
  // in current release it is not avaliable { value: NdaWorkflow.Institution, label: 'GNR_INSTITUTION' },
  { value: NdaWorkflow.Personal, label: 'GNR_ENFORCES' },
];
